import { render, staticRenderFns } from "./MathProblem.vue?vue&type=template&id=31e04461&"
import script from "./MathProblem.vue?vue&type=script&lang=js&"
export * from "./MathProblem.vue?vue&type=script&lang=js&"
import style0 from "./MathProblem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports